export default __webpack_public_path__ + "static/media/healthimage.fba6399e.jpg";